export default __webpack_public_path__ + "static/media/lose_hand.b2324496.mp3";